package org.lennycodes.hldi.pages.admin

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.await
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.attributes.rows
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*
import org.lennycodes.hldi.backend.FirebaseService
import org.lennycodes.hldi.backend.collection
import org.lennycodes.hldi.backend.doc
import org.lennycodes.hldi.backend.setDoc
import org.lennycodes.hldi.data.Event


@Composable
fun EditEventDialog(
    event: Event,
    onDismiss: () -> Unit,
    onSuccess: () -> Unit
) {

    val scope = rememberCoroutineScope()

    var isLoading by remember { mutableStateOf(false) }

    var title by remember { mutableStateOf(event.title) }
    var date by remember { mutableStateOf(event.date) }
    var location by remember { mutableStateOf(event.location) }
    var description by remember { mutableStateOf(event.description) }
    var registrationUrl by remember { mutableStateOf(event.registrationUrl) }

    var errorMessage by remember { mutableStateOf("") }


    Div(
        attrs = Modifier
            .padding(16.px)
            .then(DialogBackdropStyle.toModifier())
            .toAttrs {

                onClick {
                    if (!isLoading) {
                        onDismiss()
                    }
                }

            }
    ) {


        Div(
            attrs = Modifier
                .padding(32.px)
                .then(DialogCardStyle.toModifier())
                .toAttrs {

                    onClick {
                        it.stopPropagation()
                    }

                }
        ) {


            H3(
                attrs = DialogTitleStyle.toAttrs()
            ) {
                Text("Update Event")
            }


            @Composable
            fun inputField(
                label: String,
                value: String,
                placeholderText: String,
                onChange: (String) -> Unit
            ) {

                Div(
                    attrs = FieldGroupStyle.toAttrs()
                ) {

                    Label(
                        attrs = FieldLabelStyle.toAttrs()
                    ) {
                        Text(label)
                    }


                    Input(
                        type = InputType.Text,
                        attrs = Modifier
                            .padding(11.px,14.px)
                            .then(FieldInputStyle.toModifier())
                            .toAttrs {

                                placeholder(placeholderText)

                                this.value(value)

                                onInput {
                                    onChange(it.value)
                                }


                                if(isLoading){
                                    disabled()
                                }

                            }
                    )

                }

            }



            inputField(
                "Title",
                title,
                "Annual General Meeting"
            ){
                title = it
            }


            Div(
                attrs = FieldGroupStyle.toAttrs()
            ) {

                Label(
                    attrs = FieldLabelStyle.toAttrs()
                ) {
                    Text("Date")
                }


                Input(
                    type = InputType.Date,
                    attrs = Modifier
                        .padding(11.px,14.px)
                        .then(FieldInputStyle.toModifier())
                        .toAttrs {

                            placeholder("2026-08-20")

                            value(date)

                            onInput {
                                date = it.value
                            }


                            if(isLoading){
                                disabled()
                            }

                        }
                )

            }

            inputField(
                "Location",
                location,
                "Biharamulo District"
            ){
                location = it
            }


            inputField(
                "Registration URL (Optional)",
                registrationUrl,
                "https://example.com/register"
            ){
                registrationUrl = it
            }



            Div(
                attrs = FieldGroupStyle.toAttrs()
            ) {

                Label(
                    attrs = FieldLabelStyle.toAttrs()
                ) {
                    Text("Description")
                }


                TextArea(
                    value = description,
                    attrs = Modifier
                        .padding(11.px,14.px)
                        .then(FieldInputStyle.toModifier())
                        .toAttrs {

                            rows(4)

                            placeholder(
                                "Describe the event"
                            )

                            onInput {
                                description = it.value
                            }


                            if(isLoading){
                                disabled()
                            }

                        }
                )

            }



            if(errorMessage.isNotEmpty()) {

                P(
                    attrs = Modifier
                        .color(Color.rgb(220,53,69))
                        .fontSize(14.px)
                        .margin(0.px,0.px,16.px)
                        .toAttrs()
                ){

                    Text(errorMessage)

                }

            }



            Row(
                modifier = DialogActionsRowStyle.toModifier(),
                horizontalArrangement = Arrangement.spacedBy(12.px)
            ){


                Button(

                    enabled = !isLoading,

                    modifier = Modifier
                        .padding(11.px,22.px)
                        .then(CancelButtonStyle.toModifier()),

                    onClick = {
                        onDismiss()
                    }

                ){

                    Text("Cancel")

                }



                Button(

                    enabled = !isLoading,

                    modifier = Modifier
                        .padding(11.px,22.px)
                        .then(SaveButtonStyle.toModifier()),

                    onClick = {


                        scope.launch {


                            errorMessage = ""


                            if(title.isBlank()){

                                errorMessage =
                                    "Event title is required"

                                return@launch

                            }


                            if(date.isBlank()){

                                errorMessage =
                                    "Event date is required"

                                return@launch

                            }


                            if(location.isBlank()){

                                errorMessage =
                                    "Event location is required"

                                return@launch

                            }


                            if(description.isBlank()){

                                errorMessage =
                                    "Event description is required"

                                return@launch

                            }


                            try {


                                isLoading = true



                                val eventDocument = doc(

                                    collection(
                                        FirebaseService.db,
                                        "events"
                                    ),

                                    event.id

                                )



                                val updatedEvent = Event(

                                    id = event.id,

                                    title = title,

                                    date = date,

                                    location = location,

                                    description = description,

                                    registrationUrl = registrationUrl

                                )



                                setDoc(

                                    eventDocument,

                                    updatedEvent.toFirebaseData()

                                ).await()



                                console.log(
                                    "Event updated successfully"
                                )



                                onSuccess()

                                onDismiss()



                            } catch(e: Throwable){


                                console.error(
                                    "Updating event failed: ${e.message}"
                                )


                                errorMessage =
                                    e.message ?: "Something went wrong"


                            } finally {


                                isLoading = false

                            }


                        }


                    }

                ){

                    Text(
                        if(isLoading)
                            "Saving..."
                        else
                            "Save"
                    )

                }


            }


        }

    }

}